import { defineMessages } from 'react-intl';

export default defineMessages({
  errorInvalidTime: {
    id: 'create.step2.errorInvalidTime',
    defaultMessage: 'Enter a valid time',
  },
});
